{
  "appName": "Sahab ERP",
  "loading": "Loading…",
  "notifications": "Notifications",
  "newTab": "(opens in a new tab)",
  "currency": {
    "omr": "Omani rial"
  },
  "filters": {
    "button": "Filters",
    "title": "Filters",
    "clear": "Clear filters",
    "done": "Show results"
  },
  "quickCreate": {
    "typed": "{{label}} “{{typed}}”"
  },
  "actions": {
    "cancel": "Cancel",
    "close": "Close",
    "retry": "Try again",
    "edit": "Edit",
    "more": "More actions",
    "print": "Print",
    "save": "Save",
    "scrollBack": "Scroll back",
    "scrollForward": "Scroll forward"
  },
  "errors": {
    "title": "Something went wrong",
    "notFoundTitle": "Not found",
    "forbiddenTitle": "No access",
    "moduleDisabledTitle": "Turned off",
    "unexpected": "An unexpected error occurred. Reload the page and try again.",
    "network": "Can't reach the server. Check your connection and try again.",
    "unavailable": "The server isn't responding. Try again in a moment.",
    "unauthenticated": "Your session has ended. Sign in again to continue.",
    "forbidden": "You don't have permission for this. Ask your administrator for access.",
    "moduleDisabled": "This feature is turned off for your company. Ask your administrator to have it turned on.",
    "notFound": "This record doesn't exist, or it was removed.",
    "conflict": "This conflicts with an existing record. Check the highlighted fields.",
    "versionConflict": "Someone else changed this record. Reload to get the latest version.",
    "rateLimited": "Too many requests. Wait a moment and try again.",
    "passwordChangeRequired": "Change your password to continue.",
    "periodLocked": "The books are locked up to {{date}}: nothing dated on or before it can be posted, voided or reversed. Use a later date, or ask whoever manages fiscal years to move the lock date in Settings.",
    "periodLockedNoDate": "The books are locked for this date: nothing dated on or before the lock date can be posted, voided or reversed. Use a later date, or ask whoever manages fiscal years to move the lock date in Settings.",
    "periodLockedOff": "The books are locked up to {{date}}: nothing dated on or before it can be posted, voided or reversed. Use a later date. Accounting is turned off for your company, so nobody here can move the lock date: ask your provider.",
    "periodLockedNoDateOff": "The books are locked for this date: nothing dated on or before the lock date can be posted, voided or reversed. Use a later date. Accounting is turned off for your company, so nobody here can move the lock date: ask your provider.",
    "periodClosed": "The fiscal year for this date is closed: nothing dated in it can be posted, voided or reversed. Use a date in an open year.",
    "periodClosedOff": "The fiscal year for this date is closed: nothing dated in it can be posted, voided or reversed. Use a date in an open year. Accounting is turned off for your company, so nobody here can reopen it: ask your provider.",
    "noFiscalYear": "No fiscal year covers this date. Use another date, or ask whoever manages fiscal years to add one.",
    "noFiscalYearOff": "No fiscal year covers this date. Use another date. Accounting is turned off for your company, so nobody here can add a fiscal year: ask your provider.",
    "bankLineMatched": "Its bank line is matched on bank statement {{number}}. Unmatch it on that statement first, then try again.",
    "bankLineMatchedCompleted": "Its bank line is matched on bank statement {{number}}, which is completed. Reopen that statement and unmatch the line first, then try again.",
    "validation": "Some fields need attention. Correct them and try again.",
    "internal": "The server ran into a problem. Try again; if it keeps happening, contact support with the reference below.",
    "rejected": "The request couldn't be completed.",
    "reference": "Reference:",
    "notFoundPage": "Page not found",
    "notFoundPageBody": "The address may be mistyped, or the page has moved.",
    "goHome": "Go to home",
    "codes": {
      "MESSAGE_NOT_RETRYABLE": "Only a message that failed can be sent again.",
      "TEMPLATE_UNKNOWN_VARIABLE": "The text uses a variable this template doesn’t have. Remove it or pick one from the list.",
      "INVOICE_NOT_SENDABLE": "Only a posted invoice can be e-mailed.",
      "ADAPTER_NOT_ALLOWED_IN_ZONE": "This mail service isn’t allowed where your company’s data is kept. Use another service, or confirm your own server is approved for it.",
      "DOCUMENT_RENDERING": "The PDF is still being prepared. Try again in a moment.",
      "DOCUMENT_FAILED": "The PDF couldn’t be produced. Try issuing it again.",
      "DOCUMENT_NOT_ISSUABLE": "A PDF can’t be issued for a draft or void document.",
      "CUSTOMER_ANONYMISED": "This customer’s personal data was removed, so the record can no longer be changed or restored.",
      "RETENTION_BELOW_FLOOR": "The period is shorter than the law allows for this data. Use a longer period.",
      "LEGAL_HOLD": "This record is under a legal hold. Lift the hold first.",
      "DSR_ILLEGAL_TRANSITION": "The request can’t move to that step from where it is. Reload to see its current status.",
      "DSR_SUBJECT_REFERENCED": "This data must be kept for legal and tax records: issued documents refer to it.",
      "UPLOADS_PAUSED": "Uploads are paused while your company’s files move to another location. Try again later.",
      "RESIDENCY_MOVE_ACTIVE": "A move of this company’s data is already in progress.",
      "ZONE_NOT_CONFIGURED": "This data location isn’t available on this service yet.",
      "INVITATION_INVALID": "This invitation link isn’t valid any more. Ask your administrator to send a new one.",
      "SMTP_INCOMPLETE": "To send through your own mail server, enter its host, user name and sender address.",
      "SMTP_HOST_NOT_ALLOWED": "This mail server’s address is on a private network. Enter the public host name of your mail server.",
      "BOOKS_READ_TIMEOUT": "The books took too long to read. Try a shorter period.",
      "BOOKS_HEALTH_UNAVAILABLE": "Books health can’t be read right now. Try again in a few minutes.",
      "SALESPERSON_INVALID": "Choose an active user as the salesperson.",
      "HEALTH_PERIOD": "Books health covers a limited period at a time. Choose a shorter period.",
      "DISMISSAL_CONFLICT": "Someone else marked this finding at the same time. Reload and try again.",
      "YEAR_CLOSED": "This fiscal year is already closed. Reload to see its status.",
      "YEAR_NOT_ENDED": "A fiscal year can be closed only after its last day.",
      "PREVIOUS_YEAR_OPEN": "An earlier fiscal year is still open. Close the earlier years first.",
      "YEAR_OPEN": "This fiscal year isn’t closed, so there is nothing to reopen. Reload to see its status.",
      "LATER_YEAR_CLOSED": "A later fiscal year is closed. Reopen the later years first.",
      "DOCUMENT_ENTRY": "This entry was posted by a document. Void that document to reverse it.",
      "CLOSING_ENTRY": "This is a fiscal year’s closing entry. Reopen the fiscal year to reverse it.",
      "PRODUCT_NOT_STOCKED": "A service isn’t kept in stock, so it has no reorder level.",
      "VARIANT_ARCHIVED": "This variant was removed from its product. Reload the page.",
      "NO_WALK_IN_CUSTOMER": "The walk-in customer couldn’t be set up: another customer already uses the code WALK-IN. Change that customer’s code, then try again."
    }
  },
  "validation": {
    "required": "Required",
    "minLength": "Enter at least {{min}} characters",
    "maxLength": "Use {{max}} characters or fewer",
    "tooMany": "Choose {{max}} or fewer",
    "email": "Enter a valid email address, like name@company.om",
    "phone": "Enter a valid phone number (digits, spaces, + and - only)",
    "format": "Check the format of this value",
    "invalid": "This value isn't valid",
    "passwordLength": "Use at least 10 characters",
    "passwordSpaces": "A password can't start or end with a space",
    "passwordSame": "Choose a password different from the current one",
    "journalLine": "Enter either a debit or a credit on this line",
    "journalTwoLines": "An entry needs at least two lines",
    "describe": "Add a description",
    "positiveAmount": "Enter an amount above zero",
    "chequeNumber": "Enter the cheque number",
    "endBeforeStart": "The end date can’t be before the start date",
    "endOneWay": "Choose an end date or a number of times, not both",
    "noDateBeforeEnd": "No date falls before the end date",
    "startOnExpense": "The schedule must start on the expense’s date",
    "reason": "Give a reason",
    "accountCode": "Use letters, digits, dots or dashes",
    "sameAccount": "Choose a different account to transfer to",
    "percentage": "Enter a percentage with up to 2 decimals",
    "percentageMax": "A rate can't be more than 100%",
    "taxCategory": "Standard rates are above 0%; zero-rated, exempt and out-of-scope rates are 0%",
    "describeLine": "Describe the line or choose a product",
    "positiveQuantity": "Enter a quantity above zero",
    "negativePrice": "A price can't be negative",
    "atLeastOneLine": "Add at least one line",
    "dueBeforeInvoice": "The due date can't be before the invoice date",
    "validUntilBefore": "Valid until can't be before the quotation date",
    "activeCustomer": "Choose an active customer",
    "activeProduct": "Choose an active product",
    "activeTaxRate": "Choose an active tax rate",
    "activeWarehouse": "Choose an active warehouse",
    "wholeUnits": "This product is counted in whole units",
    "creditBeforeInvoice": "A credit note can't be dated before its invoice",
    "inactiveCustomer": "This customer is inactive. Reactivate them, or choose another customer",
    "otherCustomerInvoice": "This invoice belongs to another customer",
    "invoiceNotCreditable": "Only posted invoices can be credited",
    "returnShareTooSmall": "Return this line in larger quantities: the amounts per unit are below one baisa",
    "invoiceTaxRate": "Choose a tax rate the invoice charged",
    "invoiceTaxRateAmbiguous": "The invoice charged this tax rate at more than one percentage",
    "restoreProductToReturn": "This product is archived: restore it before taking it back",
    "debitNoteGoods": "A debit note charges services or amounts; invoice goods instead",
    "addValue": "Add at least one value",
    "oneVariant": "A product needs at least one variant",
    "cost": "Enter a cost of 0 or more, with up to 6 decimals",
    "warehouseCode": "Use letters, digits, dashes or underscores",
    "dueBeforePurchase": "The due date can't be before the purchase date",
    "activeSupplier": "Choose an active supplier",
    "goodsNoAccount": "Goods are charged to inventory; leave the account empty",
    "expenseAccount": "Choose an active expense or asset account (not a cash, bank, inventory or receivables account)",
    "chargeableAccount": "Choose an active expense or asset account (not cash/bank or an account kept by documents: inventory, receivables, payables, cheques under collection or issued, contract advances or retention, VAT)",
    "activeTreasury": "Choose an active cash or bank account",
    "methodAccount": "Choose an active account this method fits",
    "tillDrawer": "This is a till drawer: choose another account",
    "cashAccountMethods": "A cash account takes cash or cheques",
    "cashAccountOnly": "Cash goes through a cash account",
    "otherSupplierPurchase": "This purchase belongs to another supplier",
    "purchaseNotPosted": "Only posted purchases can be settled",
    "purchaseNotReturnable": "Only posted purchases can be returned or credited",
    "returnBeforePurchase": "A supplier return can't be dated before its purchase",
    "returnLineOnce": "Return each purchase line once",
    "lineNotOnPurchase": "This line is not on the purchase",
    "refundCredit": "Choose the credit to refund",
    "refundBeforeCredit": "A refund can't be dated before the credit it pays out",
    "otherCustomerCredit": "This credit belongs to another customer",
    "creditNotFound": "This credit was not found",
    "tillCode": "Use up to 32 letters, digits, dashes or underscores",
    "notNegative": "This can't be negative",
    "denomination": "Not an accepted note or coin",
    "wholeCount": "Count whole notes and coins",
    "countDrawer": "Count the drawer before closing",
    "denominationOnce": "Enter each note or coin once",
    "positiveDiscount": "Enter a discount above zero",
    "percentOver100": "A percentage can't be more than 100",
    "atLeastOneItem": "Add at least one item",
    "cashOnce": "Enter cash once",
    "noCashTender": "There is no cash tender",
    "cashTenderedShort": "The cash handed over is less than the cash tender",
    "negativeDiscount": "A discount can't be negative",
    "notDrawer": "Choose the safe or bank, not the drawer",
    "tillNotFound": "This till was not found",
    "discountOverSale": "The discount is more than the sale",
    "nonZeroAmount": "A line amount cannot be zero",
    "periodEnd": "The period cannot end before it starts",
    "outsidePeriod": "The date is outside the statement period",
    "chooseStatementLine": "Choose at least one statement line",
    "listedTwice": "A line is listed twice",
    "bankAccount": "Choose a bank account",
    "notCashAccount": "Cash accounts are counted, not reconciled: choose a bank, card or wallet account",
    "lineNotOnStatement": "A statement line is not on this statement",
    "postableAccount": "Choose an active account that can be posted to",
    "adjustmentAccount": "Choose an income or expense account (not cash/bank, receivables, payables, inventory, VAT or customer credits)",
    "cashAtTill": "Cash at the till goes into the drawer",
    "paymentMethodTaken": "A payment method with this name already exists",
    "paymentMethodTypeUsed": "Documents were recorded with this method: its type cannot change",
    "accountTakesType": "This account does not take this type",
    "activePaymentMethod": "Choose an active payment method",
    "notAtTill": "This method is not offered at the till"
  },
  "pagination": {
    "label": "Pages",
    "range": "{{from}}–{{to}} of {{total}}",
    "pageSize": "Rows per page",
    "perPage": "{{n}} per page",
    "previous": "Previous page",
    "next": "Next page",
    "page": "Page {{page}}",
    "pageOf": "Page {{page}} of {{pages}}"
  },
  "table": {
    "view": "View",
    "density": "Row density",
    "compact": "Compact",
    "comfortable": "Comfortable",
    "columns": "Columns",
    "empty": "Nothing to show.",
    "actions": "Actions",
    "rowActions": "Row actions",
    "export": "Export",
    "selectAll": "Select all on this page",
    "selectRow": "Select row",
    "selected_one": "{{n}} selected",
    "selected_other": "{{n}} selected",
    "clearSelection": "Clear selection",
    "selection": "Selected rows",
    "cannotSelect": "Can’t be selected"
  },
  "datePicker": {
    "placeholder": "dd/mm/yyyy",
    "openCalendar": "Choose from calendar",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "today": "Today",
    "clear": "Clear"
  },
  "dateRange": {
    "label": "Period",
    "preset": "Period",
    "all": "All dates",
    "thisMonth": "This month",
    "lastMonth": "Last month",
    "thisYear": "This year",
    "lastYear": "Last year",
    "custom": "Custom range",
    "from": "From",
    "to": "To",
    "thisQuarter": "This quarter",
    "lastQuarter": "Last quarter",
    "today": "Today",
    "thisWeek": "This week"
  },
  "timeline": {
    "zoom": "Scale",
    "month": "Months",
    "quarter": "Quarters",
    "showTable": "Table",
    "showChart": "Chart",
    "today": "Today",
    "roleDescription": "timeline",
    "empty": "Nothing to show in this period.",
    "noDate": "No dates",
    "bar": "{{name}}, {{start}} to {{end}}",
    "barProgress": "{{name}}, {{start}} to {{end}}, {{progress}}% complete",
    "milestone": "{{name}}, due {{date}}",
    "milestoneDone": "{{name}}, due {{date}}, achieved",
    "dragDays": "{{days}} days",
    "lateUntil": "late until {{date}}",
    "achieved": "Achieved",
    "open": "Open",
    "nextMilestone": "Next: {{name}} · {{date}} ({{done}}/{{total}} achieved)",
    "allAchieved": "All {{total}} achieved",
    "withFact": "{{text}}, {{fact}}",
    "pastEnd": "past its planned end",
    "legend": {
      "title": "Key",
      "progress": "Done so far",
      "late": "Past its planned end",
      "milestone": "Milestone",
      "milestoneDone": "Milestone achieved"
    },
    "columns": {
      "name": "Name",
      "start": "Start",
      "end": "End",
      "progress": "Progress",
      "milestones": "Milestones"
    }
  },
  "sCurve": {
    "planned": "Planned",
    "earned": "Earned",
    "spent": "Spent",
    "forecast": "Forecast",
    "budget": "Budget",
    "today": "Today",
    "showTable": "Show as table",
    "recorded": "Recorded",
    "live": "Today, not yet recorded",
    "formula": "Calculation changed",
    "endsAt": "→ {{amount}} · {{date}}",
    "endsOn": "→ {{date}}",
    "finalCost": "Expected final cost, finishing {{date}}",
    "finalCostNoDate": "Expected final cost"
  },
  "treeTable": {
    "expand": "Expand",
    "collapse": "Collapse",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all"
  },
  "profileTabs": {
    "goTo": "Go to {{tab}}"
  },
  "weekGrid": {
    "total": "Total",
    "dayTotal": "Total for {{day}}",
    "rowTotal": "Total for {{row}}",
    "weekTotal": "Week total",
    "over24": "over 24 hours",
    "hint": "Enter hours like 7.5, 7:30 or 7h30.",
    "invalid": "Enter hours like 7.5, 7:30 or 7h30, up to 24.",
    "locked": "Locked",
    "readOnly": "Read only",
    "options": "Row options",
    "today": "Today",
    "restDay": "rest day",
    "cell": "{{row}}, {{day}}",
    "keys": "Arrow keys move between days and rows. Type to enter hours, Enter to keep them, Escape to undo, Delete to clear."
  }
}
